import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';
import { DriveServiceProvider } from '../drive-service/drive-service';
import { StoreWrapProvider } from '../store-wrap/store-wrap';
import { ConfigApiServiceProvider } from '../config-api-service/config-api-service';
// import { ClickBlock } from 'ionic-angular/umd/components/app/click-block';

@Injectable()
export class MailSchedulerProvider {
  mailSt:any = {From :'',To:[],cc:[],bcc:[],Subject:'',Body:'',attachment:[],type:'',template:this.driveService.objCurrentParentFolder.template[0].id};
  objCurrentTemplate:any;
  constructor(public toastMessage:ToastController,public driveService:DriveServiceProvider, private storeWrap:StoreWrapProvider, private configApiService:ConfigApiServiceProvider) {
    console.log('Hello MailSchedulerProvider Provider');
  }

  constructMail(mailFields) {
    for (let key in this.mailSt) {
      if (mailFields.hasOwnProperty(key)) {
        this.mailSt[key] = mailFields[key];
      }
    }
    console.log('mailST', this.mailSt);
    return this.mailSt;
  }

  ScheduleMail(ScheduleDateTime, mailSt) {
    this.sendMail(mailSt);
  }

  sendMail(mailSt) {
    let data = Object.assign({}, this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id]['pushParams'], mailSt, { 'action': 'update' });
    delete data['template'];
    delete data['attachment'];
    delete data['type'];
    data['To'] = data['To'].toString();
    data['cc'] = data['cc'].toString();
    data['bcc'] = data['bcc'].toString();
    this.configApiService.pushRequest(data, (respData) => {
      if (respData == "SUCCESS") {
        var message = this.toastMessage.create({
          message: 'Mail Sent Successfully',
          duration: 2000
        });
        message.present();
      }
    });
  }

  getMailTemplateFields(fdata, cbck) {
    this.objCurrentTemplate = this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id];
    let data = Object.assign({},this.configApiService.driveApi.PullIdmManager.params,fdata);
    this.configApiService.pullRequest(data, (respData)=>{
      cbck(respData)
    });
  }

  SaveMailTemplate() {

  }
}



// WEBPACK FOOTER //
// ./src/providers/mail-scheduler/mail-scheduler.ts